//MENU TOGGLE

document.querySelector(".btn-menu-mobile").addEventListener("click", toggleMenu );

function toggleMenu() {
    document.querySelector(".menu-list").classList.toggle("menu-open");
}

// LANGUAGE SWITCHER

const languageSwitcherButton = document.querySelector('[data-language-current-lang]');
const currentLanguageLink = document.querySelector('.polylang_langswitcher .current-lang');

languageSwitcherButton.textContent = currentLanguageLink.textContent;